import {useGetUniversityFeaturesQuery} from "../types";
import {useSpaces} from "../StudentApp/SpacesProvider";

/**
 * Checks if the university has a feature enabled, designed to use the
 * currently selected space university but can be overridden
 * @param slug the university slug to search (defaults to selected space if not provided)
 * @returns function that takes a feature name and returns if it is enabled or not
 */
export function useUniversityFeature(slug = "") {
    const {selectedSpace} = useSpaces();

    const {data} = useGetUniversityFeaturesQuery({
        variables: {
            universitySlug: slug ?? selectedSpace?.slug,
        },
    });

    const isFeatureEnabled = (feature: string) => {
        if (!feature || !data?.university?.config?.features) return false;

        const universityContentValues = data?.university?.config?.features?.find(
            (item) => item?.feature?.name === feature,
        );
        return (
            universityContentValues?.enabledByUnibuddy &&
            universityContentValues?.enabledByUniversity
        );
    };

    return {
        isFeatureEnabled,
    };
}
